import { useParams } from 'react-router-dom';
import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchCampaignItem } from 'api/campaigns';
import { useCurrentCampaign } from 'customHooks/useCurrentCampaign';
import { campaignQueryKeys } from 'queries/campaign-query-keys';
import { CampaignItem } from 'types/domain';

interface CampaignItemRouteParams {
    account_id: string;
    campaign_id: string;
    itemId: string;
}

const useCurrentCampaignItem = <T = CampaignItem,>() => {
    const { itemId: itemIdFromParams } = useParams<CampaignItemRouteParams>();
    const { data: campaign } = useCurrentCampaign();
    const itemId = parseInt(itemIdFromParams);

    return useSuspenseQuery({
        queryKey: campaignQueryKeys.item(campaign.id, itemId),
        queryFn: () =>
            fetchCampaignItem<T>({
                campaignId: campaign.id,
                itemId,
                include: 'highest_bid',
            }),
    });
};

export type { CampaignItemRouteParams };
export { useCurrentCampaignItem };
